var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.classes,on:{"click":_vm.onClick}},[_c('div',{staticClass:"mdl-color-text--grey-900"},[_vm._v(" "+_vm._s(_vm.emojiImage)+" "+_vm._s(_vm.emojiCode)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }